import { CurrentChatStatus, ScrollToBottom } from "@/app/store/types";
import { Button } from "@douyinfe/semi-ui";
import styles from "./NewMessageTips.module.scss";
import React from "react";
import { useMessageStore } from "@/app/store";
import { ScrollAction, ScrollFrom } from "@/app/hooks/useReadScrollToBottom";
import Locale from "@/app/locales";
import { sleep } from "@/app/utils/async";

export default function NewMessageTips({
  handleScrollToBottom,
  pageVisible,
}: {
  handleScrollToBottom: ScrollToBottom;
  pageVisible?: boolean;
}) {
  const {
    chatStatus,
    getUnreadMessages,
    setCurrentChatStatus,
    bottomReached,
    resetUnreadCount,
  } = useMessageStore();
  if (
    (chatStatus && [CurrentChatStatus.ChatEnd].includes(chatStatus)) ||
    getUnreadMessages().length === 0 ||
    // 当页面可见，并且在最底部，不显示
    (pageVisible && bottomReached)
  ) {
    return;
  }

  const handleUnReadClick = async () => {
    setCurrentChatStatus(CurrentChatStatus.Online);
    resetUnreadCount();
    await sleep(0);
    handleScrollToBottom?.(
      ScrollAction.FORCE_TO_BOTTOM,
      ScrollFrom.NEW_MESSAGE,
    );
  };
  return (
    <Button
      theme="borderless"
      onClick={handleUnReadClick}
      type="tertiary"
      className={styles.newMessageUnRead}
    >
      <svg
        className={styles.icon}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 15l7-7 7 7"
        ></path>
      </svg>
      {Locale.chat.newMessageTips.replace(
        "{0}",
        `${getUnreadMessages().length}`,
      )}
    </Button>
  );
}
